/**
 * @author    Nikko Renolds
 * @package		Trap Tycoon
 * @link		  https://github.com/Ni1kko/Trap-Tycoon
 * @copyright (c) Fallox Developments2026.
 * @license		MIT
 * @description Frontend component displaying the hitlist of targets with bounties.
 */
import React, { useEffect, useState } from "react";
import { Target, Skull } from "lucide-react";
import { callBackend } from "../utils/api";

export default function Hitlist({ onInspect }) {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    callBackend("/hitlist/fetch").then(setHits);
  }, []);

  return (
    <div className="bg-black border-2 border-red-900 p-6 font-mono shadow-[0_0_30px_rgba(153,27,27,0.2)]">
      <div className="flex items-center gap-3 mb-6 border-b border-red-900/30 pb-4">
        <Target className="text-red-600" size={32} />
        <h2 className="text-4xl font-black italic uppercase text-white">
          The Hitlist
        </h2>
      </div>

      <div className="grid gap-4">
        {hits.length === 0 && (
          <p className="text-zinc-600 uppercase text-xs italic">
            The streets are clean... for now.
          </p>
        )}
        {hits.map((hit) => (
          <div
            key={hit.id}
            className="bg-zinc-900 border border-zinc-800 p-4 flex justify-between items-center group hover:border-red-600 transition-all"
          >
            <div>
              <h3 className="text-lg font-bold text-white uppercase">
                {hit.target_name}
              </h3>
              <p className="text-[10px] text-zinc-500 uppercase italic">
                "{hit.reason}"
              </p>
            </div>
            <div className="text-right flex items-center gap-4">
              <div>
                <p className="text-[9px] text-zinc-600 uppercase">
                  Current Bounty
                </p>
                <p className="text-xl font-black text-red-600">
                  ${hit.bounty_amount.toLocaleString()}
                </p>
              </div>
              <button
                onClick={() => onInspect(hit.target_id)}
                className="bg-red-700 hover:bg-red-500 text-black p-2 transition-colors"
              >
                <Skull size={20} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
